import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { ICustoRecursoModel } from '../models/custo-recurso.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class CustoRecursoService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(pesquisa: string, ativo: boolean, simplificado = false): Promise<IBaseModel<ICustoRecursoModel[]>> {
    let params = new HttpParams();
    params = params.append('pesquisa', pesquisa || '');

    if (ativo !== undefined) {
      params = params.append('ativo', ativo.toString());
    }

    if (simplificado) {
      params = params.append('simplificado', simplificado.toString());
    }

    return this.httpClient
      .get<IBaseModel<ICustoRecursoModel[]>>(`${this.apiBaseUrl}/custoRecurso`, { params })
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<ICustoRecursoModel>> {
    return this.httpClient
      .get<IBaseModel<ICustoRecursoModel>>(`${this.apiBaseUrl}/custoRecurso/${id}`)
      .toPromise();
  }

  public async inserir(data: ICustoRecursoModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/custoRecurso`, data)
      .toPromise();
  }

  public async atualizar(data: ICustoRecursoModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/custoRecurso/${data.id}`, data)
      .toPromise();
  }

  public async reativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/custoRecurso/${id}/reativar`, {})
      .toPromise();
  }

  public async inativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/custoRecurso/${id}/inativar`, {})
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/custoRecurso/${id}`)
      .toPromise();
  }
}
